interface LanguageStrings {
  [key: string]: string;
  LOADING: string;
  SAVING: string;
  SAVE_COMPLETE: string;
  ZOOM_IN_ERROR: string;
  ZOOM_ERROR: string;
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: string;
  ONE_TOPIC_MUST_BE_SELECTED: string;
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: string;
  SAVE_COULD_NOT_BE_COMPLETED: string;
  MAIN_TOPIC: string;
  SUB_TOPIC: string;
  ISOLATED_TOPIC: string;
  CENTRAL_TOPIC: string;
  ENTITIES_COULD_NOT_BE_DELETED: string;
  CLIPBOARD_IS_EMPTY: string;
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: string;
  RELATIONSHIP_COULD_NOT_BE_CREATED: string;
  SESSION_EXPIRED: string;
  CENTRAL_TOPIC_CONNECTION_STYLE_CAN_NOT_BE_CHANGED: string;
  CENTRAL_TOPIC_STYLE_CAN_NOT_BE_CHANGED: string;
  TAB_TO_CREATE_CHILD: string;
  ENTER_TO_CREATE_SIBLING: string;
  PLUS_TOOLTIP_CREATE_CHILD: string;
  PLUS_TOOLTIP_CREATE_SIBLING: string;
}

const KO: LanguageStrings = {
  LOADING: '로딩 중..',
  SAVING: '저장 중...',
  SAVE_COMPLETE: '저장 완료',
  ZOOM_IN_ERROR: '확대가 너무 큽니다.',
  ZOOM_ERROR: '더 이상 확대/축소할 수 없습니다.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: '토픽을 생성할 수 없습니다. 하나의 토픽만 선택해야 합니다.',
  ONE_TOPIC_MUST_BE_SELECTED: '토픽을 생성할 수 없습니다. 토픽을 선택해야 합니다.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: '하위 항목을 접을 수 없습니다. 하나의 토픽을 선택해야 합니다.',
  SAVE_COULD_NOT_BE_COMPLETED: '저장할 수 없습니다. 나중에 다시 시도해주세요.',
  MAIN_TOPIC: '주요 토픽',
  SUB_TOPIC: '하위 토픽',
  ISOLATED_TOPIC: '독립 토픽',
  CENTRAL_TOPIC: '중심 토픽',
  ENTITIES_COULD_NOT_BE_DELETED: '토픽 또는 관계를 삭제할 수 없습니다. 하나 이상의 항목을 선택해야 합니다.',
  CLIPBOARD_IS_EMPTY: '복사할 내용이 없습니다. 클립보드가 비어 있습니다.',
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: '중심 토픽은 삭제할 수 없습니다.',
  RELATIONSHIP_COULD_NOT_BE_CREATED: '관계를 생성할 수 없습니다. 먼저 상위 토픽을 선택해야 합니다.',
  SESSION_EXPIRED: '세션이 만료되었습니다. 다시 로그인해주세요.',
  CENTRAL_TOPIC_CONNECTION_STYLE_CAN_NOT_BE_CHANGED: '중심 토픽의 연결 스타일은 변경할 수 없습니다.',
  CENTRAL_TOPIC_STYLE_CAN_NOT_BE_CHANGED: '중심 토픽은 선 스타일로 변경할 수 없습니다.',
  TAB_TO_CREATE_CHILD: '하위 토픽 만들기',
  ENTER_TO_CREATE_SIBLING: '형제 토픽 만들기',
  PLUS_TOOLTIP_CREATE_CHILD: '하위 토픽 만들기',
  PLUS_TOOLTIP_CREATE_SIBLING: '형제 토픽 만들기',
};

export default KO;
